<template>

<div class="card px-2 py-4">
    <vs-table :data="domains">
      <template slot="thead">
        <vs-th class="font-medium">
          {{ $t('Platform') }}
        </vs-th>
        <vs-th class="font-medium">
          {{ $t('Type') }}
        </vs-th>
        <vs-th class="font-medium">
          {{ $t('CPM') }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr class="tr-border" v-for="(platform, index) in data" :key="'custom-domain-' + index">

            <vs-td>
              <div class="price-floor-platform">
                {{ platform.title }}
              </div>
            </vs-td>

          <vs-td>
            <div :class="platform.type == 'websites' ? 'website-dot' : 'mobile-application-dot'"></div>
            <div class="price-floor-type">
              {{ platform.type }}
            </div>
          </vs-td>

        <vs-td>

          <div class="price-floor-edit-icon" v-if="!editable">
              <span class="underline">${{ platform.minbid || 0 }}</span>
              <vs-icon @click="enableEditingCustomBid()" class="ml-2 cursor-pointer" style="font-size: 15px;" icon="speakol-edit" icon-pack="speakol"></vs-icon>
          </div>

          <div v-else class="grid grid-cols-2 gap-1">
            <speakol-input
              class="bidInput"
              :placeholder="`$${platform.minbid || 0}/CPM`"
            />
            <div class="flex w-28 items-center" style="height: 40px;">
              <vs-icon class="save-new-cpm" @click="editCustomBid(platform)" style="font-size: 24px;" icon="speakol-save" icon-pack="speakol"></vs-icon>
              <vs-icon class="cancel-new-cpm" @click="disableEditingCustomBid()" style="font-size: 24px;" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
            </div>

          </div>

        </vs-td>

        </vs-tr>
      </template>
    </vs-table>

</div>

</template>

<script>
export default {
  props: {
    domains: {
      type: Array
    }
  },
  data () {
    return {
      editable: false
    }
  },

  methods: {
    enableEditingCustomBid () {
      this.editable = true
    },
    disableEditingCustomBid () {
      this.editable = false
    }
  }

}
</script>

<style lang="scss" scoped>

  .card {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    border-radius: 10px;
  }

  .bidInput {
    width: 90;
    height: 40;
  }

  .website-dot {
    background-color: #0092d7;
    width: 10px;
    height: 10px;
    float: left;
    margin-right: 5px;
    margin-top: 5px;
    border-radius: 100%;
  }

  .mobile-application-dot {
    background-color: #6dc0ad;
    width: 10px;
    height: 10px;
    float: left;
    margin-right: 5px;
    margin-top: 5px;
    border-radius: 100%;
  }

  .vs-button-primary.vs-button-filled:hover {
    box-shadow: none !important;
  }

  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    transform: none !important;
  }

  .tr-border {
    border-bottom: 1px solid rgba(189, 195, 202, 0.215527);
    height: 60px;
  }

  .save-new-cpm {
    color: #34b576;
    font-size: 13px !important;
    background: rgba(244, 244, 244, 0.745629);
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
    padding: 5px;
  }

  .cancel-new-cpm {
    color: #e02020;
    font-size: 13px !important;
    background: rgba(244, 244, 244, 0.745629);
    border-radius: 4px;
    cursor: pointer;
    padding: 5px;
  }

  .price-floor-platform {
    text-overflow: ellipsis;
    overflow: hidden;
    width: auto;
    white-space: nowrap;
  }

  .price-floor-input {
    .vs-input--input.normal {
      width: 90px;
    }
  }
</style>